// Yields one parsed object per non-blank line; a line split across chunks is held until its
// newline arrives, and a trailing line without one is dropped.
export async function* ndjsonStream(stream) {
    const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
    let buffer = "";

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += value;
        let boundary;
        while ((boundary = buffer.indexOf("\n")) !== -1) {
            const line = buffer.slice(0, boundary).trim();
            buffer = buffer.slice(boundary + 1);
            if (line) yield JSON.parse(line);
        }
    }
}
